<template>
  <div class="AddPayInfo">
    <QS-h4-title title="支付信息" />
    <el-form
      :model="publicInfo"
      label-width="140px"
    >
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item
            prop="accountName"
            :label="`账户名称${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="publicInfo.accountName"
              placeholder="请输入"
              clearable
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="accountNo"
            :label="`开户账号${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="publicInfo.accountNo"
              placeholder="请输入"
              clearable
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="bankName"
            :label="`开户银行${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="publicInfo.bankName"
              placeholder="请输入"
              clearable
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template v-if="Number(addFormData.customerType) === 2">
      <QS-h4-title title="开票信息" />
      <el-form
        :model="enterpriseCustomerInfo"
        label-width="140px"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              prop="taxType"
              :label="`税票类型${columnSeparator}`"
            >
              <el-select
                placeholder="请选择"
                v-model="enterpriseCustomerInfo.taxType"
                clearable
              >
                <el-option
                  v-for="item in taxTypeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              prop="taxPersonName"
              :label="`纳税人名称${columnSeparator}`"
            >
              <el-input
                v-space="true"
                v-model="enterpriseCustomerInfo.taxPersonName"
                placeholder="请输入"
                clearable
                maxlength="64"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              prop="taxNo"
              :label="`纳税人识别号${columnSeparator}`"
            >
              <el-input
                v-space="true"
                v-model="enterpriseCustomerInfo.taxNo"
                placeholder="请输入"
                clearable
                maxlength="64"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              prop="invoiceBankName"
              :label="`开户行${columnSeparator}`"
            >
              <el-input
                v-space="true"
                v-model="enterpriseCustomerInfo.invoiceBankName"
                placeholder="请输入"
                clearable
                maxlength="64"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              prop="invoiceAccountNo"
              :label="`银行账号${columnSeparator}`"
            >
              <el-input
                v-space="true"
                v-model="enterpriseCustomerInfo.invoiceAccountNo"
                placeholder="请输入"
                clearable
                maxlength="64"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              prop="invoiceTel"
              :label="`电话${columnSeparator}`"
            >
              <el-input
                v-space="true"
                v-model="enterpriseCustomerInfo.invoiceTel"
                placeholder="请输入"
                clearable
                maxlength="64"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              prop="invoiceAddress"
              :label="`地址${columnSeparator}`"
            >
              <el-input
                type="textarea"
                v-model="enterpriseCustomerInfo.invoiceAddress"
                placeholder="请输入"
                clearable
                maxlength="200"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    addFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    addFormData: {
      handler(val) {
        if (Number(this.addFormData.customerType) === 1 && val.individualCustomerVo) {
          this.publicInfo = {
            accountName: val.individualCustomerVo.accountName || '',
            accountNo: val.individualCustomerVo.accountNo || '',
            bankName: val.individualCustomerVo.bankName || '',
          }
        } else if (val.enterpriseCustomerVo) {
          this.publicInfo = {
            accountName: val.enterpriseCustomerVo.accountName || '',
            accountNo: val.enterpriseCustomerVo.accountNo || '',
            bankName: val.enterpriseCustomerVo.bankName || '',
          }
          this.enterpriseCustomerInfo = {
            taxType: val.enterpriseCustomerVo.taxType,
            taxNo: val.enterpriseCustomerVo.taxNo || '',
            taxPersonName: val.enterpriseCustomerVo.taxPersonName || '',
            invoiceTel: val.enterpriseCustomerVo.invoiceTel || '',
            invoiceAddress: val.enterpriseCustomerVo.invoiceAddress || '',
            invoiceBankName: val.enterpriseCustomerVo.invoiceBankName || '',
            invoiceAccountNo: val.enterpriseCustomerVo.invoiceAccountNo || '',
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      // 个人企业都有
      publicInfo: {
        accountName: '', // 账户名称
        accountNo: '', // 开户账号
        bankName: '', // 开户银行
      },
      // 企业
      enterpriseCustomerInfo: {
        taxType: '', // 税票类型
        taxNo: '', // 纳税人识别号
        taxPersonName: '', // 纳税人名称
        invoiceTel: '', // 开票电话
        invoiceAddress: '', // 开票地址
        invoiceBankName: '', // 开票开户行
        invoiceAccountNo: '', // 开票银行账号
      },
    }
  },
  computed: {
    // 税票类型
    taxTypeList() {
      return this.dictParseList(selectOption.taxTypeList)
    },
  },
}
</script>

<style>

</style>
